/* LOCATION / CURRENCY */

window.onload = function () {
  const links = document.querySelectorAll(".select-location-link");

  links.forEach((link) => {
    link.addEventListener("click", function handleClick(event) {
      var subdom = link.getAttribute("data-subdom");
      var path = document.location.pathname;
      var host = location.hostname;
      if (host.charAt(2) == ".") {
        var host = host.slice(3); // remove existing region subdomain
      }
      path = path.replace("en-ca/", ""); // remove ca if present
      if (subdom == "us") {
        var dest = "https://" + host + path;
      } else {
        var dest = "https://" + subdom + "." + host + path;
      }
      //alert("host = " + host_nosubdom + "\nsubdom = " + subdom + "\n" + dest);
      window.location.href = dest;
      e.preventDefault();
    });
  });
};

/* END LOCATION / CURRENCY */

/* CUSTOM VIDEO CONTROLS */

// $(document).ready(function () {
//   $("video").each(function () {
//     var video = $(this);
//     var playbutton = $(this).siblings(".video-button-play");
//     var videoElement = video.get(0);
//     if (video.attr("autoplay") != "autoplay") {
//       playbutton.fadeTo(200, 1);
//     }
//   });

//   $(".video-button-play").click(function (e) {
//     //console.log('VIDEO clicked');
//     var video = $(this).siblings("video");
//     if (video.prop("paused")) {
//       video.trigger("play");
//       $(this).fadeTo(200, 0);
//       //console.log('VIDEO play');
//     } else {
//       video.trigger("pause");
//       $(this).fadeTo(200, 1);
//       //console.log('VIDEO pause');
//     }
//     video.on("ended", function () {
//       //console.log('VIDEO ended');
//       $(this).siblings(".video-button-play").fadeTo(200, 1);
//     });
//     e.preventDefault();
//   });
// });

/* END CUSTOM VIDEO CONTROLS */
